export function Footer() {
  return (
    <footer className="footer-react">
      <div className="footer-container-react">
        <div className="footer-item-react">
          Copyright © {new Date().getFullYear()} Deloitte Development LLC. All rights reserved.
        </div>
        <div className="footer-item-react">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www2.deloitte.com/us/en/legal/privacy.html"
          >
            Privacy
          </a>
          <span className="footer-separator-react">|</span>
          <a target="_blank" rel="noopener noreferrer" href="https://cookienotice.deloitte.com">
            Cookies
          </a>
          <span className="footer-separator-react">|</span>
          <button type="button" className="optanon-toggle-display footer-link-button-react">
            Cookie Settings
          </button>
        </div>
      </div>
    </footer>
  );
}
